import React from "react";
import EstimateAddContent from "../content/estimateAddContent";
import Layout from "../layout/Layout";

function EstimateAdd() {
  return (
    <Layout>
      <EstimateAddContent />
    </Layout>
  );
}

export default EstimateAdd;
